export default __webpack_public_path__ + "static/media/20_header_return.73e3d2b9.png";